import {FunctionComponent} from "react";
import {useSyncConnectorLogic} from "./SyncConnector.logic";


export const SyncConnector: FunctionComponent = () => {
  useSyncConnectorLogic();
  return null;
}
